import { UseMutationOptions, useMutation } from "@tanstack/react-query"

import { userUpdateSchemaValidationType } from "@tfg/types/schemas/user"

import { httpClient } from "~/backend/axios.ts"

export const useUpdateUser = (
  options?: UseMutationOptions<
    userUpdateSchemaValidationType,
    unknown,
    userUpdateSchemaValidationType
  >
) => {
  return useMutation({
    ...options,
    mutationFn: async (user) => {
      const response = await httpClient.patch(`users/${user.id}`, user)
      return response.data
    },
    onSuccess: (data, variables, onMutateResult, context) => {
      options?.onSuccess?.(data, variables, onMutateResult, context)
    },
  })
}
